import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DealsWizardModel } from '../../../_models/_index';
import { DealStepEnum, DealStatusEnum } from '../../../_enums/_index';
import { GeneralService } from '../../../services/general.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'deal-details',
    moduleId: module.id,
    templateUrl: 'deal-details.component.html'

})

export class DealDetailsComponent implements OnInit, OnChanges {
    tzHasError: boolean = false;

    @Input()
    dealsWizard: DealsWizardModel;

    @Input()
    dealStep: DealStepEnum;

    @Output()
    private nextStepEvent: EventEmitter<DealStepEnum>;

    //@Output()
    //private keyboardShownEvent: EventEmitter<any>;
   

    constructor(private generalService: GeneralService,
        private userService: UserService
    ) {
        this.nextStepEvent = new EventEmitter<DealStepEnum>();
        //this.keyboardShownEvent = new EventEmitter<any>();
    }

    ngOnInit() {
        //this.dealsWizard.isTrial = true;
    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    isReadOnly()
    {
        return this.dealsWizard.statusID > 3;
    }

    ngOnChanges() {

    }

    onKey(e: KeyboardEvent) { 
        if ((e.keyCode >= 48 && e.keyCode <= 57) ) {
            return false;
        }
        return true;
    }


    validateEmail() {
        var email = this.dealsWizard.email;
        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
        if (email == '' || !re.test(email)) {
            
            return false;
        }
        return true;
    }

    validate()
    {
        let validate: boolean = true;

        validate = !this.dealsWizard.contactIdentityNumber || this.validateTZ(this.dealsWizard.contactIdentityNumber);
        validate = validate && this.validateEmail();

        return validate;
    }

    nextStep() {
        if (this.validate()) {
            this.dealStep = this.dealsWizard.isTrial ? this.dealStep + 2 : this.dealStep + 1;
            this.nextStepEvent.emit(this.dealStep);            
        }
       
    }

    prevStep() {
        this.dealStep = this.dealStep - 1;
        this.nextStepEvent.emit(this.dealStep);
    }

    validateTZ(num) {
        this.tzHasError = !this.generalService.validateTZ(num);

        return !this.tzHasError;
    }

    isTrialCBReadOnly() {
        let result = false;
        if (this.userService.isCustomer()) {
            if (this.dealsWizard.statusID > 1)
                result = true;
        }
        else if (this.dealsWizard.statusID > 3)
            result = true;

        return result;
    }

    isRequired() {
        return this.userService.isCustomer() ;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-details/deal-details.component.ts